import {FC} from "react"
import {Trans} from "react-i18next"
import {ReactSVG} from "react-svg"

import homeVector from "@frontend/design/icons/home-vector.svg"
import {useTranslation} from "@frontend/i18n"
import {css, cx} from "@styled-system/css"
import {iconsColor} from "@styled-system/patterns"

export const SupportedExplanation: FC = () => {
  const t = useTranslation()

  const guideToLines = [
    "home.supported.supportedList.1",
    "home.supported.supportedList.2",
    "home.supported.supportedList.3",
    "home.supported.supportedList.4",
  ]

  return (
    <div
      className={css({
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        fontSize: "1.1em",
        width: "100%",
        marginTop: "0px",
        color: "text.quaternary",
      })}
    >
      <div
        className={css({
          ...containerCss,
          borderRadius: 10,
          background: "background.tertiary",
        })}
      >
        <h5
          className={css({
            fontWeight: "bold",
            marginBottom: 5,
          })}
        >
          <Trans t={t} i18nKey="home.supported.supportedHeader">
            <span
              className={css({
                color: "background.brand.accent",
              })}
            />
          </Trans>
        </h5>
        <ul>
          {guideToLines.map((line) => (
            <li
              key={line}
              className={css({
                display: "flex",
                alignItems: "center",
              })}
            >
              <ReactSVG
                src={homeVector}
                className={cx(
                  iconsColor({color: "background.quaternary"}),
                  css({
                    marginRight: 10,
                    "& svg": {
                      width: 10,
                      height: 10,
                    },
                  }),
                )}
              />
              <p>
                {
                  <Trans t={t} i18nKey={line}>
                    <span
                      className={css({
                        fontWeight: "bold",
                      })}
                    />
                  </Trans>
                }
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

const containerCss = {
  padding: 20,
  flexGrow: 1,
}
